import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=59e049c0&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=59e049c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e049c0",
  null
  
)

export default component.exports